// extracted by mini-css-extract-plugin
export default {"overlay":"Modal-module__overlay--0BXXk","content":"Modal-module__content--afKRv","actionButtons":"Modal-module__actionButtons--RJHXZ","okBtn":"Modal-module__okBtn--Uh8rm"};